var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Search results for Facebook - Flaticon-2"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Subtraction 5",
  d: "M16 32H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4h-6V21h3l2-5h-5v-4a1.157 1.157 0 0 1 .113-.549.693.693 0 0 1 .312-.3A2.448 2.448 0 0 1 23.493 11H26V6h-4a6.007 6.007 0 0 0-6 6v4h-4v5h4v11Z",
  fill: "#fff"
}))));
export default SvgFacebook;